import { createApp } from 'vue';
import Mp3ToOggConverter from '@/Components/Mp3ToOggConverter.vue';
import '@styles/app.css';

createApp(Mp3ToOggConverter).mount('#mp3-to-ogg-converter');
